var map = {
	"./DrLubhani/ChangeColor": [
		803,
		187
	],
	"./Ganga/ChangeColor": [
		805,
		193
	],
	"./Indus/ChangeColor": [
		807,
		206
	],
	"./Kabini/ChangeColor": [
		809,
		213
	],
	"./Kaveri/ChangeColor": [
		717,
		22
	],
	"./Luni/ChangeColor": [
		811,
		219
	],
	"./Narmada/ChangeColor": [
		813,
		222
	],
	"./Nethravathi/ChangeColor": [
		815,
		229
	],
	"./Neyyar/ChangeColor": [
		817,
		234
	],
	"./Periyar/ChangeColor": [
		819,
		237
	],
	"./SAANVI/ChangeColor": [
		821,
		247
	],
	"./Sabarmathi/ChangeColor": [
		823,
		254
	],
	"./Sparsh/ChangeColor": [
		825,
		260
	],
	"./Sutlej/ChangeColor": [
		827,
		264
	],
	"./Yamuna/ChangeColor": [
		829,
		270
	],
	"./pamba/ChangeColor": [
		831,
		279
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2081;
module.exports = webpackAsyncContext;